import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CarePlan/create-full-careplan`;

export const CreateFullCarePlan = async (carePlanData) => {
try {
    const response = await axios.post(API_URL, carePlanData, {
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json"
    },
    });

    return response.data; // { message, patientCarePlanId }
} catch (error) {
    console.error("❌ Error al crear el Care Plan completo:", error.response?.data || error.message);
    throw error;
}
};
